module.exports = __webpack_public_path__ + "img/2.93125c0d.png";